import type { ReactNode } from 'react'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from './app-sidebar'
import { Topbar } from './topbar'

interface AppShellProps {
  children: ReactNode
}

export function AppShell({ children }: AppShellProps): React.ReactNode {
  return (
    <SidebarProvider className="h-svh overflow-hidden">
      <AppSidebar />
      <SidebarInset className="h-full overflow-y-auto">
        <Topbar />
        <main id="main-scrollable-area" className="flex-1 p-6">
          {children}
        </main>
      </SidebarInset>
    </SidebarProvider>
  )
}
